import React from "react";
import "./style.scss";
import { FormattedMessage } from "react-intl";

const CurrentStep = ({ title, primaryColor }) => {
  const notGivingForm =
    title === "Media Upload" || title === "Registration" || title === "Confirm Campaign"
      ? true
      : false;

  return (
    <li aria-current="step">
      <span className="current-step-text" style={{ color: `${primaryColor}` }}>
        {title === "Gift" && <FormattedMessage id="gift" />}
        {title === "Gift Information" && <FormattedMessage id="giftInformation" />}
        {title === "Details" && <FormattedMessage id="details" />}
        {title === "Confirmation" && <FormattedMessage id="confirmation" />}
        {title === "Payment" && <FormattedMessage id="payment" />}
        {notGivingForm && title}
      </span>
    </li>
  );
};

export default CurrentStep;
